/**
 * Workout logs (client) – log completion for program exercises.
 */
import { collection, getDocs, addDoc, doc, setDoc, query, where, orderBy, limit, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION = 'workoutLogs';

export function workoutLogRepository({ getFirestore = () => db } = {}) {
  const firestore = getFirestore();
  const coll = () => collection(firestore, COLLECTION);

  return {
    async create(data) {
      const ref = await addDoc(coll(), { ...data, createdAt: new Date() });
      return ref.id;
    },
    async update(logId, data) {
      const ref = doc(firestore, COLLECTION, logId);
      await setDoc(ref, data, { merge: true });
    },
    async updateCoachNote(logId, { coachNote, coachNoteBy }) {
      const ref = doc(firestore, COLLECTION, logId);
      await setDoc(ref, { coachNote: coachNote ?? null, coachNoteBy: coachNoteBy ?? null, coachNotedAt: serverTimestamp() }, { merge: true });
    },
    async listByClientAndProgram(clientId, programId, limitCount = 200) {
      const q = query(
        coll(),
        where('clientId', '==', clientId),
        where('programId', '==', programId),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      );
      const snap = await getDocs(q);
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    },
  };
}

export const workoutLogRepo = workoutLogRepository();
